import React from "react";
import { useEffect } from "react";
import { useState } from "react";

import styled from "styled-components";
import { BranchService } from "../../model/branch";
import { DefaultEditorValue, GetCreateTable } from "../../core/Helper2";
import { BuildsColumnsWithEdit } from "../../core/TableHelper";
import { FieldParams } from "../../core/FieldObject";
import { AiFillAlert } from "react-icons/ai";
import { TopToolBar } from "../../core/TopToolbar";
import DocuBranchEditor from "./b0004-docubranch-editor";

const branchFields = {
  BrchID: { ...new FieldParams("BrchId", ""), isHiddenColumn: true },
  BrchCode: { ...new FieldParams("BrchCode", "รหัสสาขา") },
  BrchShort: { ...new FieldParams("BrchShort", "ชื่อสาขา") },
  Company: { ...new FieldParams("Company.CompShortName", "สังกัด") },
};

export default function DocuBranchSetup() {
  const _idFiledsName = "BrchID";
  const [table, setTable] = useState();
  const [editor, setEditor] = useState(DefaultEditorValue);
  const [branchs, setBranchs] = useState([]);

  useEffect(() => {
    loadBranch();
    return () => {
      setBranchs([]);
      setTable(null);
    };
  }, []);

  useEffect(() => {
    setTable(
      GetCreateTable({
        idFieldName: _idFiledsName,
        columns: BuildsColumnsWithEdit(branchFields, (col, row) => {
          showEditor(row[_idFiledsName], row);
        }),
        data: branchs,
      })
    );
  }, [branchs]);

  const loadBranch = async (text) => {
    let result = await BranchService.GetNewList({ text: text ?? "" });
    if (result) {
      setBranchs(result ?? []);
    } else {
      setBranchs([]);
    }
  };

  const searchHandler = (text) => {
    loadBranch(text);
  };

  const showEditor = (idValue, row) => {
    setEditor((pv) => ({
      ...pv,
      show: true,
      idFieldName: _idFiledsName,
      idValue: idValue,
      rowData: row,
      action: () => {
        // getData();
      },
    }));
  };

  return (
    <MainContainer>
      <DivDocuList></DivDocuList>
      <DivBrachSearcher>
        <TopToolBar
          title={"เลือกสาขาเพื่อจัดการเอกสาร"}
          searchHandler={searchHandler}
          icon={<AiFillAlert color="yellow" size="30" />}
        />
        {table}
      </DivBrachSearcher>
      <DocuBranchEditor {...{ editor: [editor, setEditor] }} />
    </MainContainer>
  );
}

const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const DivDocuList = styled.div``;
const DivBrachSearcher = styled.div`
  padding-inline: 50px;
`;
